/** The bet every fixture round was played at, and the balance the offline server answers with. */
export const OFFLINE_ROUND = { betMinor: "100", balanceMinor: "100000" } as const;
